'use client';

import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import type { LinearSliderProps } from './LinearSlider/LinearSlider.client';
import { LinearSlider } from './LinearSlider/LinearSlider.client';
import type { CircleSliderProps } from './CircleSlider/CircleSlider.client';
import { CircleSlider } from './CircleSlider/CircleSlider.client';

export type SliderProps = LinearSliderProps | CircleSliderProps;

/**
 * payment plan row atom
 *
 * displays a payment plan row
 *
 * */
export const Slider = (props: SliderProps) => {
  const { isMobile } = useDeviceType();

  if (isMobile) {
    return <CircleSlider {...props} />;
  }
  return <LinearSlider {...props} />;
};
